import { render, staticRenderFns } from "./ArticleDialog.vue?vue&type=template&id=45ef5adc&"
import script from "./ArticleDialog.vue?vue&type=script&lang=ts&"
export * from "./ArticleDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports